// @flow

// Utils
import createReducer from 'fc-utils/createReducer'

// Initial State
import tableState from './initialState'
import datatable from './datatable'

// Assets Operator
import {
  initialState as operatorState,
  reducers as operatorReducers,
} from 'hfty-operator-comments'

// Exports
export default createReducer({
  ...tableState,
  ...operatorState,
}, {
  ...datatable.reducers,
  ...operatorReducers,
})
